import React from 'react';
import { byPrefixAndName } from '@awesome.me/kit-4d9140695b/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Label, Paragraph, Title } from '../../typography';
import { Link } from '../../atoms/Link/link';
import { FontAwesomeIcon as FontAwesomeIconEnum } from '../../types/fontAwesomeIcons';

export type SectionHeadingProps = {
  sectionTitle: string;
  linkText?: string;
  onClick?: () => void;
  href?: string;
  subheading?: string;
};

export function SectionHeading({ sectionTitle, linkText, onClick, href, subheading }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between gap-4">
        <Title size="small">{sectionTitle}</Title>
        <Paragraph color="neutral-500" className="md:hidden">
          {subheading}
        </Paragraph>
        {!!linkText && (
          <Label size="small">
            <Link onClick={onClick} {...(href && { href })}>
              {linkText}
              <FontAwesomeIcon icon={byPrefixAndName.fausb[FontAwesomeIconEnum.ArrowRight]} />
            </Link>
          </Label>
        )}
      </div>
      <Paragraph color="neutral-500" className="hidden md:block">
        {subheading}
      </Paragraph>
    </div>
  );
}
